import { Proposition } from '@ecosystem/newron-client-collections';
import { Context } from '../types';

export const getParamsForContext = (context: Context) => {
  const params = {};
  const { settings, filters } = context;
  Object.keys(settings?.values || {}).forEach(name => {
    const values = settings.values[name];
    if (values) {
      params[name] = values.map(e => `${e.value}|${e.label}`);
    }
  });
  Object.keys(filters?.values || {}).forEach(name => {
    const values = filters.values[name];
    if (values) {
      params[`f:${name}`] = values.map(e => `${e.value}|${e.label}`);
    }
  });
  return params;
};

export const getPropositionFromContext = (context: Context): Proposition => {
  const prop = context.settings.values.proposition?.[0]?.value;
  switch (prop) {
    case Proposition.Market:
      return Proposition.Market;
    case Proposition.DistributionPanel:
      return Proposition.DistributionPanel;
    default:
      return Proposition.Market;
  }
};
